import React, { createContext, useContext, useState } from "react";
import { soulManager } from "../managers/SoulManager";
import { SoulDataModel } from "../models/soul/SoulDataModel";

export interface UserDataContextType {
  data: SoulDataModel;
  permittedPaths: string[];
  reloadUserData: () => Promise<void>;
}

const UserDataContext = createContext<UserDataContextType | undefined>(
  undefined
);

export const UserDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [userData, setUserData] = useState<SoulDataModel>();
  const [permittedPaths, setPermittedPaths] = useState<string[]>([]);

  async function getUserData() {
    const data = await soulManager.getSoul();
    setUserData(data);
    const paths = data?.paths!;
    paths.push("/dashboard");
    setPermittedPaths(data?.paths!);
  }

  const value: UserDataContextType = {
    data: userData!,
    permittedPaths,
    reloadUserData: getUserData,
  };

  return (
    <UserDataContext.Provider value={value}>
      {children}
    </UserDataContext.Provider>
  );
};

export function useUserData() {
  return useContext(UserDataContext);
}
